import { render, staticRenderFns } from "./SwitchLang.vue?vue&type=template&id=0204ac72&scoped=true"
import script from "./SwitchLang.vue?vue&type=script&lang=js"
export * from "./SwitchLang.vue?vue&type=script&lang=js"
import style0 from "./SwitchLang.vue?vue&type=style&index=0&id=0204ac72&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0204ac72",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\workspace\\abroad-hrms-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0204ac72')) {
      api.createRecord('0204ac72', component.options)
    } else {
      api.reload('0204ac72', component.options)
    }
    module.hot.accept("./SwitchLang.vue?vue&type=template&id=0204ac72&scoped=true", function () {
      api.rerender('0204ac72', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SwitchLang.vue"
export default component.exports